<div class="elm-application-list-item-info elm-text-left" fxFlex fxLayout="row" fxLayoutAlign="start center">
  <elm-icon [icon]="application.icon"></elm-icon>

  <div>
    <h3 class="elm-spacing-2xs">{{ application.name }}</h3>
    <p class="elm-no-margin">
      <strong>{{ subtitle }}</strong>
      <ng-container *ngIf="application.last_login">
        -
        <em>
          {{ 'applicationListItem.lastLoggedIn' | transloco : { date: application.last_login | elmFromDateToNow } }}
        </em>
      </ng-container>
    </p>
  </div>
</div>

<div class="elm-application-list-item-status">
  <elm-progress-spinner *ngIf="showProgress; else chipTpl" [value]="progress">{{ progress }}%</elm-progress-spinner>
</div>

<ng-template #chipTpl [ngSwitch]="showCustomerStatusText">
  <elm-app-status-chip *ngSwitchCase="false" [value]="status"></elm-app-status-chip>

  <elm-chip *ngSwitchCase="true" [bgColor]="status | elmDecisionColor">
    {{ statusDecisionLabel }}
  </elm-chip>
</ng-template>
